/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * Cells for Account Table
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.12.0
 * @since 1.0.0
 */
import { EColumnCell, EColumnFilter } from '../../../../../components/Table/types/columnTypes';
import { PersonalAccountField } from '../../../../../types/personalAccountTypes';

const cellConfig: { [Key in PersonalAccountField]: number } = {
    assistantCampaignsCount: 160,
    balance: 156,
    coordinatorCampaignsCount: 160,
    contract: 156,
    inn: 100,
    kpp: 100,
    loyaltyBonusBalance: 200,
    loyaltyStatus: 200,
    name: 244,
    number: 164,
    persDataLockDate: 272,
    persDataStatusName: 270,
    regionName: 160,
    subdivisionKpp: 140,
    subdivisionName: 140,
    subsCount: 132,
    unpaidBillsCount: 202,
};
const getColumnFilterType = (name: string): string => {
    switch (name) {
        case PersonalAccountField.unpaidBillsCount:
        case PersonalAccountField.subsCount:
        case PersonalAccountField.balance:
        case PersonalAccountField.loyaltyBonusBalance:
            return EColumnFilter.filterRange;
        case PersonalAccountField.assistantCampaignsCount:
        case PersonalAccountField.coordinatorCampaignsCount:
        case PersonalAccountField.loyaltyStatus:
            return EColumnFilter.filterSelect;
        case PersonalAccountField.contract:
        case PersonalAccountField.inn:
        case PersonalAccountField.kpp:
        case PersonalAccountField.name:
        case PersonalAccountField.number:
        case PersonalAccountField.persDataStatusName:
        case PersonalAccountField.regionName:
        case PersonalAccountField.subdivisionKpp:
        case PersonalAccountField.subdivisionName:
            return EColumnFilter.filterMultiSelect;
        case PersonalAccountField.persDataLockDate:
            return EColumnFilter.filterDate;
        default:
            return '';
    }
};
const getColumnCellType = (name: string): string => {
    switch (name) {
        case PersonalAccountField.number:
            return EColumnCell.linkAccount;
        case PersonalAccountField.unpaidBillsCount:
            return EColumnCell.linkUnpaidBillsNumber;
        case PersonalAccountField.assistantCampaignsCount:
        case PersonalAccountField.coordinatorCampaignsCount:
            return EColumnCell.linkCampaignNumber;
        case PersonalAccountField.subsCount:
            return EColumnCell.count;
        case PersonalAccountField.balance:
            return EColumnCell.balance;
        case PersonalAccountField.loyaltyBonusBalance:
            return EColumnCell.balanceScore;
        case PersonalAccountField.persDataLockDate:
            return EColumnCell.dateCell;
        case PersonalAccountField.persDataStatusName:
            return EColumnCell.persDataStatusName;
        default:
            return EColumnCell.text;
    }
};

const getColumnFixedType = (name: string): string | boolean => {
    switch (name) {
        case PersonalAccountField.number:
            return 'left';
        default:
            return false;
    }
};

export {
    cellConfig,
    getColumnCellType,
    getColumnFilterType,
    getColumnFixedType,
};
